import type { PartnerOrigin, PartnerTenant } from '@shipium-corp/shipium-ts-types';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { assetService } from '~/services';
import { Descriptions } from 'antd';
import { ShipiumTag } from '~/components/shared/ShipiumTag';
import type { DescriptionsItemProps } from 'antd/lib/descriptions/Item';
const { Item } = Descriptions;

type TenantMap = Record<string, PartnerTenant>;

export const useTenantMap = (options?: Partial<UseQueryOptions<TenantMap>>) => {
  return useQuery<TenantMap>({
    queryKey: ['partner-management-service', 'tenants-map'],
    queryFn: async () => {
      const tenants = await assetService.fetchTenants({});
      const tenantMap = tenants.reduce((acc: Record<string, PartnerTenant>, tenant) => {
        acc[tenant.tenantId ?? ''] = tenant;
        return acc;
      }, {});
      return tenantMap;
    },
    ...options,
  });
};
type OriginMap = Record<string, PartnerOrigin>;
export const useOriginMap = (options?: Partial<UseQueryOptions<OriginMap>>) => {
  return useQuery<OriginMap>({
    queryKey: ['partner-management-service', 'origins-map'],
    queryFn: async () => {
      const origins = await assetService.fetchOrigins({});
      const originMap = origins.reduce((acc: Record<string, PartnerOrigin>, origin) => {
        acc[origin.originId] = origin;
        return acc;
      }, {});
      return originMap;
    },
    ...options,
  });
};

export const historicalShipmentFilterDetails = ({
  assetFilters,
  ...props
}: {
  assetFilters: { tenants?: string[]; origins?: string[] };
} & Partial<DescriptionsItemProps>) => {
  const { tenants = [], origins = [] } = assetFilters;

  if (!tenants.length && !origins.length) return null;

  return (
    <Item label="Historical Shipment Filters" {...props}>
      <Descriptions column={1}>
        {!!tenants.length && (
          <Item label="Tenants">
            {tenants.map((name) => (
              <ShipiumTag key={name} color="Teal" wrap>
                {name}
              </ShipiumTag>
            ))}
          </Item>
        )}
        {!!origins.length && (
          <Item label="Origins">
            {origins.map((name) => (
              <ShipiumTag key={name} color="Teal" wrap>
                {name}
              </ShipiumTag>
            ))}
          </Item>
        )}
      </Descriptions>
    </Item>
  );
};
